/*
*
* Version : 1.0.0
* 04/09/2016 - 10h18
*
*! Octave Web7 !*/

(function () {
  'use strict';

  angular
    .module('app.service.compare', [])

    /* @ngInject */
    .factory('CompareService', ["$rootScope", "$http", "$q", "$cookies", "$location", "DateService", function ($rootScope, $http, $q, $cookies, $location, DateService) {
      if (typeof $location.search().c !== 'undefined') {
        var arr = $location.search().c.split(',');
        angular.forEach(arr, function (value, key) {
          arr[key] = parseInt(value);
        });
        $cookies.putObject('comparator', arr, {
          path: '/',
          expires: DateService.tomorrow()
        });
      }

      var products = $cookies.getObject('comparator') || [],
        open = '0';


      var promises = {};

      function updateCookie() {
        var search = $location.search();
        if (!products.length) {
          search = angular.extend(search, {c: [], open: []});
          $location.query(search);
          $cookies.remove('comparator');
          $rootScope.$broadcast('comparatorEmpty');
          return;
        }
        search = angular.extend(search, {c: products.join(','), open: open === '1' ? open : []});
        $location.query(search);
        $cookies.putObject('comparator', products, {
          path: '/',
          expires: DateService.tomorrow()
        });
      }

      function cancelPromises() {
        angular.forEach(promises, function (value, key) {
          promises[key].resolve('aborted');
        });
        promises = {};
      }

      return {
        getNbProducts: function () {
          return products.length;
        },
        get: function () {
          return products;
        },
        add: function (id) {
          cancelPromises();
          products.push(id);
          updateCookie();
        },
        remove: function (id) {
          cancelPromises();
          var index = products.indexOf(id);
          if (index !== -1) {
            products.splice(products.indexOf(id), 1);
            updateCookie();
          }
        },
        toggle: function (value) {
          open = value ? '1' : '0';
          updateCookie();
        },
        empty: function () {
          products = [];
          updateCookie();
        },
        getProduct: function (id) {
          var canceller = $q.defer();
          promises[id] = canceller;
          return $http({
            method: 'GET',
            url: '/o-p-' + id,
            cache: true,
            headers: {
              'Content-type': 'application/json',
              'X-Requested-With': 'jsonHttpRequest'
            },
            timeout: canceller.promise
          })
          .then(function (response) {
            delete promises[id];
            return response.data;
          })
          .catch(function (error) {
            throw error;
          });

        }
      };
    }]);

})();
